

import Dashboard from "../Pages/Dashboard";
import DesignationMaster from "../Pages/Master/DesignationMaster";
import DistrictMaster from "../Pages/Master/DistrictMaster";
import GradeMaster from "../Pages/Master/GradeMaster";
import HolidayMaster from "../Pages/Master/HolidayMaster";
import LeaveMaster from "../Pages/Master/LeaveMaster";
import QualificationMaster from "../Pages/Master/QualificationMaster";
import ShiftMaster from "../Pages/Master/ShiftMaster";
import VillageMaster from "../Pages/Master/VillageMaster";
import ZoneManagerMaster from "../Pages/Master/ZoneMangerMaster";
import ZoneMaster from "../Pages/Master/ZoneMaster";
import Attendance from "../Pages/Attendance";
import EmployeeRegistration from "../Pages/EmployeRegistration";
import SendNotification from "../Pages/Notification";
import EmpLeaveReport from "../Pages/EmpLeaveReport";
import EmpDetail from "../Pages/EmpDetail";
import Main from "../Pages/Main";

export const routes = [
  {
    id: 1,
    path: "/dashboard",
    component: <Dashboard />,
    navItem: "Dashboard",
  },
  {
    id: 2,
    path: "/master",
    component: <DesignationMaster />,
    navItem: "Designation Master",
  },
  {
    id: 3,
    path: "/district_master",
    component: <DistrictMaster />,
    navItem: "Master",
  },
  {
    id: 4,
    path: "/zone_manager",
    component: <ZoneManagerMaster />,
    navItem: "Block Manger Master",
  },
 {
    id: 5,
    path: "/zone_master",
    component: <ZoneMaster />,
    navItem: "Block Master",
  },
   {
    id: 6,
    path: "/village_master",
    component: < VillageMaster/>,
    navItem: "Village Master",
  },
  {
    id: 7,
    path: "/qualification_master",
    component: <QualificationMaster/>,
    navItem: "Qualification Master",
  },
 {
    id: 8,
    path: "/grade_master",
    component: <GradeMaster/>,
    navItem: "Grade Master",
  },
   {
    id: 9,
    path: "/leave_master",
    component: <LeaveMaster/>,
    navItem: "Leave Master",
  },
   {
    id: 10,
    path: "/holiday_master",
    component: <HolidayMaster/>,
    navItem: "Holiday Master",
  },
   {
    id: 11,
    path: "/shift_master",
    component: <ShiftMaster/>,
    navItem: "Shift Master",
  },
  {
    id: 12,
    path: "/employee_registration",
    component: <EmployeeRegistration/>,
    navItem: "Employee Registration",
  },
   {
    id: 13,
    path: "/employee_attendance",
    component: <Attendance/>,
    navItem: "Employee Attendance",
  },
    {
    id: 14,
    path: "/send_notification",
    component: <SendNotification/>,
    navItem: "Send Notification",
  },
    {
    id: 15,
    path: "/emp_leave_report",
    component: <EmpLeaveReport/>,
    navItem: "Employee Leave Report",
  },
      {
    id: 16,
    path: "/emp/:id",
    component: <EmpDetail/>,
    navItem: "Employee ",
  },
  {
    id: 17,
    path: "/main",
    component: <Main />,
    navItem: "Main",
  },

];